import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Product } from '../../entities/product.entities'
import { Item } from '../../entities/item.entities'
import { ProductService } from '../../services/product.service'
import { CartService } from '../../services/cart.service'
import { BuyService } from '../../services/buyservice'
import { AuthService } from '../../services/AuthService'
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Router } from '@angular/router';
@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit {

  private items: Item[];
  private showSelect: boolean = true;
  private selected = 'bank';
  private showCreate;
  private showPass: boolean = false;
  private totalMoney: number;
  private quatity: any;
  private checkLogin: any;

  CreateWayBuy: FormGroup;

  Fullname: any = '';
  Companyname: any = '';
  Courty: any = 'thai';
  address: any = '';
  amphor: any = '';
  province: any = '';
  provinceCode: any = '';
  Callnumber: any = '';
  Email: any = '';
  bank: any = '';
  sentType: any = '';

  sentMoney: number = 20;
  errordata: boolean = false;

  cheToggle: boolean = false;

  CheckuserData;
  DataUsers;
  constructor(public fb: FormBuilder, private router: Router, private activatedRoute: ActivatedRoute, private productService: ProductService, private cartService: CartService, public authService: AuthService, public buy: BuyService) { }
  ngOnInit() {
    // Get User Data
    let userDataTemp;
    userDataTemp = this.authService.getUserData();
    userDataTemp.subscribe((snap => {
      if (snap.length == 0) {
        this.CheckuserData = false;
        this.cheToggle = true;
      } else {
        this.authService.afAuth.authState.subscribe(res => {
          for (var i = 0; i < snap.length; i++) {
            if (snap[i].uid == res.uid) {
              this.DataUsers = snap[i]
            }
          }
        })
      }
    }))
    // Check Authen Email And Login
    this.Email = this.authService.email
    this.checkLogin = this.authService.email;
    if (this.authService.email == null) {
      this.router.navigate(['Login'])
    }
    this.quatity = this.cartService.loadCount()

    if (this.quatity == 0) {
      localStorage.removeItem('cart')
    }
    this.items = this.cartService.getCart()
  }
  toggleAddData() {
    this.cheToggle = !this.cheToggle;
  }
  changeSentType(event) {
    //console.log(event.target.value)
    if (event.target.value == 'ธรรมดา') {
      this.sentMoney = 20;
    } else {
      this.sentMoney = 40;
    }
  }
  onclick(select: string) {
    this.selected = select;
  }
  showCreateNewAccount(showCreateNewAccount: string) {
    this.showCreate = showCreateNewAccount;
    if (this.showPass == true) {
      this.showCreate = !showCreateNewAccount;
      this.showPass = false;
    }
  }
  addCart(id: string) {
    this.cartService.pushCart(id)
    this.items = this.cartService.getCart()
  }
  deleteCart(value: string) {
    this.cartService.decrementCart(value)
    this.items = this.cartService.getCart()
  }
  deleteItem(i) {
    this.cartService.deleteItem(i)
    this.items = this.cartService.getCart()
  }
  onBuy() {

    // Check login รึยัง
    if (this.authService.email) {

      // Check เคยบันทึกข้อมูลแล้วรึยัง
      if (this.CheckuserData == false || this.DataUsers == null) {

        // Check สินค้าอยู่ในตระกร้าไหม
        if (this.cartService.totalPrice != 0) {


          if (this.Fullname != '' && this.Courty != '' && this.address != '' && this.amphor != '' && this.province != '' && this.provinceCode != '' && this.Callnumber != '' && this.bank != '' && this.sentType != '') {
            let dataBuy = {
              Fullname: this.Fullname,
              Companyname: this.Companyname,
              Courty: this.Courty,
              address: this.address,
              amphor: this.amphor,
              province: this.province,
              provinceCode: this.provinceCode,
              CallNumber: this.Callnumber,
              Email: this.Email,
              sentType: this.sentType,
            }
            this.authService.addDataUser(dataBuy)
            this.buy.buyProduct(this.items, dataBuy, this.bank, this.cartService.totalPrice, this.sentMoney);
          } else {
            this.errordata = true;
            alert(" ข้อมูลไม่ครบถ้วน ")
          }

        } else {
          alert(" ไม่มีายการ สินค้าที่สั่ง ")
        }

      } else if (this.DataUsers != null && this.cheToggle == false) {

        let dataBuy = {
          Fullname: this.DataUsers.address.Fullname,
          Companyname: this.DataUsers.address.Companyname,
          Courty: this.DataUsers.address.Courty,
          address: this.DataUsers.address.address,
          amphor: this.DataUsers.address.amphor,
          province: this.DataUsers.address.province,
          provinceCode: this.DataUsers.address.provinceCode,
          CallNumber: this.DataUsers.address.CallNumber,
          Email: this.DataUsers.address.Email,
          sentType: this.DataUsers.address.sentType,
        }
        this.buy.buyProduct(this.items, dataBuy, this.bank, this.cartService.totalPrice, this.sentMoney);

      } else if (this.DataUsers != null && this.cheToggle == true) {
        if (this.Fullname != '' && this.Courty != '' && this.address != '' && this.amphor != '' && this.province != '' && this.provinceCode != '' && this.Callnumber != '' && this.bank != '' && this.sentType != '') {
          let dataBuy = {
            Fullname: this.Fullname,
            Companyname: this.Companyname,
            Courty: this.Courty,
            address: this.address,
            amphor: this.amphor,
            province: this.province,
            provinceCode: this.provinceCode,
            CallNumber: this.Callnumber,
            Email: this.Email,
            sentType: this.sentType,
          }
          this.authService.updateDataUser(dataBuy,this.DataUsers.uid)
          this.buy.buyProduct(this.items, dataBuy, this.bank, this.cartService.totalPrice, this.sentMoney);
        } else {
          this.errordata = true;
          alert(" ข้อมูลไม่ครบถ้วน ")
        }
      }

    } else {
      // Check login รึยัง
      this.router.navigate(['Login'])
    }

  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/cart/cart.component.ts